export default function isValidEmail(email: string) {
  return email.includes('@');
}
